export const cardTypes = {
  adult: {
    value: 1,
    name: '成人',
    icon: 'adult',
  },
  child: {
    value: 2,
    name: '少儿',
    icon: 'child',
  },
  personal: {
    value: 3,
    name: '私教',
    icon: 'personal',
  },
  major: {
    value: 4,
    name: '专业班',
    icon: 'major',
  },
};

export function getCardTypeNameByType(type) {
  for (let key in cardTypes) {
    if (cardTypes[key].value === type) return cardTypes[key].name;
  }
}

export function getCardTypeIconByType(type) {
  for (let key in cardTypes) {
    if (cardTypes[key].value === type) return cardTypes[key].icon;
  }
}
